"use client";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import {
  fetchEmployeeProfile,
  selectCurrentEmployeeProfile,
} from "../../../../redux/features/employeeProfileSlice";
import ActiveCases from "./ActiveCases";
import CaseStats from "./CaseStats";
import LeadTypes from "./LeadTypes";
import PerformanceChart from "./PerformanceChart";
import ProfileCard from "./ProfileCard";

export default function MainEmployeeProfile() {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const userId = params.id;

  const { isLoading, error } = useSelector((state) => state.employeeProfile);
  const currentProfile = useSelector(selectCurrentEmployeeProfile);

  useEffect(() => {
    if (userId) {
      dispatch(fetchEmployeeProfile(userId));
    }
  }, [userId, location.key, dispatch]);

  if (isLoading || !currentProfile) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="w-8 h-8 border-4 border-blue-800 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (error && !currentProfile) {
    return (
      <div className="text-red-500 text-center py-4">
        Error loading employee profile: {error}
      </div>
    );
  }

  const employeeName = currentProfile?.name || "Employee";

  return (
    <div onClick={()=>console.log(currentProfile)} className="md:p-4">
      <h1 className="text-2xl font-medium mb-6">{employeeName}</h1>

      {currentProfile && <div className="grid grid-cols-1 xl:grid-cols-12 gap-5">
        <div className="min-w-0 xl:col-span-3 space-y-6">
          <ProfileCard profile={currentProfile.agentDetails} />
          <ActiveCases cases={currentProfile?.ActiveLeadsList} />
          <div className="xl:hidden">
            <CaseStats stats={currentProfile} />
          </div>  
        </div>

        <div className="min-w-0 xl:col-span-6 space-y-6">
          <PerformanceChart performanceData={currentProfile?.EmployeePerformance} />
          <LeadTypes leadTypes={currentProfile?.TypesOfLeads} />
        </div>

        <div className="hidden xl:block xl:col-span-3 min-w-0">
          <CaseStats stats={currentProfile} />
        </div>
      </div>}
    </div>
  );
}
